import React from "react";
import Card from "../../components/page/Card";
import { AppContext } from "../../contexts/AppContext";
import Format from "../../helpers/Format";

function Congelada() {
  const { session, orangiuzWhatsApp, baseUrl } = React.useContext(AppContext);

  return (
    <div
      style={{
        background: "linear-gradient(to right, #FF6507, #FF0CB5)",
      }}
    >
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <div className="col-lg-4 mt-4 mx-2 text-center">
          <Card>
            <h3 className="mb-4" style={{ color: "#d9534f" }}>
              Acesso Bloqueado!
            </h3>
            <p style={{ color: "#0b0b0b", fontSize: "1.2rem" }}>
              O acesso de sua empresa foi bloqueado na plataforma da Orangiuz
              por falta de pagamento. Entre em contato com o suporte para
              regularizar sua situação.
            </p>

            <div className="row justify-content-center">
              <img
                src={`${baseUrl}/assets/images/meAjuda/Canais-de-Atendimento.png`}
                style={{ width: "25%", marginTop: "20px" }}
                alt="Canais de atendimento"
                className="mx-auto"
              />
            </div>
            <div className="row text-center">
              <h5 style={{ color: "#0b0b0b" }}>Canais de atendimento</h5>
            </div>
            <div className="row mt-3">
              <h6 style={{ textAlign: "center" }}>
                Nosso time de Orangers ficará muito feliz em ajudá-lo através
                dos seguintes canais:
              </h6>
            </div>
            <div className="row mt-3">
              <div className="row">
                <a
                  href="mailto:meajuda@orangiuz.com.br"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 style={{ textAlign: "center", fontWeight: "lighter" }}>
                    <i className="mdi mdi-email-outline"></i>{" "}
                    meajuda@orangiuz.com.br
                  </h6>
                </a>
              </div>
              {["3", "4"].includes(session?.plano) ? (
                <div className="row">
                  <a
                    href={`https://wa.me/${orangiuzWhatsApp}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <h6 style={{ textAlign: "center", fontWeight: "lighter" }}>
                      <i className="mdi mdi-email-outline"></i>{" "}
                      {Format.formataCelular(
                        orangiuzWhatsApp && orangiuzWhatsApp.substring(2)
                      )}
                    </h6>
                  </a>
                </div>
              ) : (
                <></>
              )}
            </div>
            <div className="mt-4">
              <button
                className="btn btn-success btn-lg"
                onClick={() => {
                  window.location.href = baseUrl + "login";
                }}
              >
                OK
              </button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default Congelada;
